import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Filter from './Filter';
import GrantView from './GrantView';
import Results from './filtersResults';
import SelectedHitProvider from './GrantView/SelectedHitProvider';
import styles from './page.module.css';
import { useAuth } from './AuthContext';
// Legacy GrantDB login modal retained for reference. GrantDB now uses the
// application's primary Firebase session and redirects signed-out users.
// import LoginModal from './loginfirebase';
import NavBar from '../../Components/NavBar'; // <-- Import the shared NavBar

// Step 8: Algolia removed. Filters and search run in the browser over the
// grants the page already downloads.
export default function Home() {
  const { idToken, authReady } = useAuth();

  const [currentClient, setCurrentClient] = useState(null);

  if (!authReady) return null;
  if (!idToken) return <Navigate to="/login" replace />;

  return (
    <div className={styles.page}>
      <NavBar />
      <div style={{ height: '48px' }} /> {/* Spacer for fixed NavBar */}
      {/* Legacy second-login flow intentionally disabled.
      {!idToken && (
        <LoginModal
          isOpen={isLoginOpen}
          onClose={() => setIsLoginOpen(false)}
        />
      )} */}
      {
        <>
          {/* Step 29 (owner): the toolbar row that used to sit here is gone —
              it held nothing for columns 1 and 2 and left an empty band under
              the header. The count line of column 2 now has that top row; the
              Update banner sits in column 3's matching top slot. */}

          {/* Filters span the page; results and grant details share the row below. */}
          <div className={styles.layout}>
            <aside className={`${styles.col} ${styles.colLeft}`}>
              <Filter onCurrentClientChange={setCurrentClient} />
            </aside>

            <SelectedHitProvider>
             <main className={`${styles.col} ${styles.colCenter}`}>
                <Results />
             </main>

            <section className={`${styles.col} ${styles.colRight}`}>
              {/* Step 30: the top slot stays (it keeps the rows level with
                  column 2's count line) but the out-of-date "Update: the
                  Hide/Hidden feature…" banner is gone from it. */}
              <div className={styles.colBody}>
                <GrantView currentClient={currentClient} />
              </div>
            </section>
            </SelectedHitProvider>

          </div>
        </>
      }
    </div>
  );
}
